import React from 'react';
import cn from 'classnames';

import { Avatar } from 'components/shared/Avatar';

import styles from './SchoolPreview.module.scss';

const SchoolPreview = ({
  className,
  preview,
  size,
  name,
  email,
}: {
  className: any;
  preview: any;
  size: any;
  name: any;
  email: any;
}) =>
  preview ? (
    <img className={cn(styles.preview, className)} src={preview} />
  ) : (
    <Avatar
      className={cn(styles.preview, className)}
      size={size}
      text={name || email}
    />
  );

SchoolPreview.defaultProps = {
  size: 'sm',
};

export default React.memo(SchoolPreview) as any;
